// "What's New" window — a small overlay listing the player-facing changelog (newest first).
// Data comes from src/content/changelog.ts; add releases there, not here.

import { CHANGELOG, type ChangeCategory } from '../../content/changelog';

const CATEGORY_ORDER: ChangeCategory[] = ['Added', 'Changed', 'Balance', 'Fixed'];

export function ChangelogWindow({ onClose }: { onClose: () => void }) {
  return (
    <div className="overlay changelogoverlay" onClick={onClose}>
      <div className="changelogwin" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="What's New">
        <div className="changeloghead">
          <h2>What’s New</h2>
          <button className="changelogclose" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="changelogbody">
          {CHANGELOG.map((v) => {
            // group entries by category, preserving CATEGORY_ORDER
            const groups = CATEGORY_ORDER.map((cat) => ({
              cat,
              items: v.entries.filter((e) => e.category === cat),
            })).filter((g) => g.items.length > 0);
            return (
              <section className="changelogver" key={v.version}>
                <div className="changelogverhead">
                  <span className="changelogvernum">v{v.version}</span>
                  <span className="changelogvertitle">{v.title}</span>
                  <span className="changelogverdate">{v.date}</span>
                </div>
                {groups.map((g) => (
                  <div className="changeloggroup" key={g.cat}>
                    <div className={`changelogtag tag-${g.cat.toLowerCase()}`}>{g.cat}</div>
                    <ul>
                      {g.items.map((e, i) => (
                        <li key={i}>{e.text}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </section>
            );
          })}
        </div>
      </div>
    </div>
  );
}
